
import { withTranslation } from "react-i18next";
import { useModel } from "../../contexts/modelContextNew";
import { ITranslationPros } from "../controlsPropertiesInterface";
import { IPropsField, IPropsInputChange } from "./fieldPropertiesInterfaceNew";
import modelHelper from "./modelHelperNew";
import "./toogleField.scss";

type IPropsToggleButtonField = IPropsField & IPropsInputChange & ITranslationPros;

function ToggleButtonField({
  id,
  model,
  attr,
  value,
  label,
  name,
  onChange,
  t
}: IPropsToggleButtonField) {
  const modelContext = useModel();
  const modelState = model || modelContext;

  const { getBooleanValue, setValue } = modelHelper({
    model: modelState,
    attr,
    value: undefined,
    onChange
  });

  const domId = `toggle-${id || attr || label}-${name || "default"}`.replace(/\s+/g, "-").toLowerCase();
  const checked = getBooleanValue();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.checked);
  };

  return (
    <div className="toggle-row">
      <label className="switch" htmlFor={domId}>
        <input
          id={domId}
          type="checkbox"
          className="btn-toggle"
          checked={checked}
          onChange={handleChange}
          aria-label={label ? t(label) : label}
          aria-checked={checked}
          role="switch"
        />
        <span className="slider" />
      </label>
      <span className="toggle-label">{label ? t(label) : label}</span>
    </div>
  );
}

export default withTranslation()(ToggleButtonField);